// extracted by mini-css-extract-plugin
module.exports = {"rates":"rates-module--rates--2Fu_v","unitCol":"rates-module--unitCol--YA53v"};